import { render, staticRenderFns } from "./instagramFeed.vue?vue&type=template&id=9ee97c3c&scoped=true&"
import script from "./instagramFeed.vue?vue&type=script&lang=js&"
export * from "./instagramFeed.vue?vue&type=script&lang=js&"
import style0 from "./instagramFeed.vue?vue&type=style&index=0&id=9ee97c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee97c3c",
  null
  
)

export default component.exports